<template>
  <div class="fixed top-0 right-0 z-8000 ml-auto">
    <Transition
      enter-from-class="translate-x-full"
      enter-class="translate-x-full transition-all ease-in-out  transform"
      enter-to-class="translate-x-0"
      leave-from-class="translate-x-0"
      leave-class="translate-x-0 transition-all ease-in-out  transform"
      leave-to-class="translate-x-full"
    >
      <div
        v-if="isOpen"
        class="mt-6 ml-1 flex justify-end transition-all duration-300"
      >
        <component :is="displayRef?.component" v-bind="displayRef" />
      </div>
    </Transition>
  </div>
</template>
<script setup lang="ts">
import { useToast } from './useToast';

const { displayRef, isOpen } = useToast();
</script>
